import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error("Faltan VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY en .env.local");
}

// Sin el genérico Database: supabase-js 2.110 cambió su forma interna de tipar los schemas
// (requiere __InternalSupabase) y no compensa perseguirla para una app de un solo usuario.
// El tipado de dominio se mantiene igual vía las interfaces de ./types/database en cada hook.
export const supabase = createClient(url, anonKey);
